import DOMPurify from 'dompurify';
const sanitizeHTML = (input) => {
    return DOMPurify.sanitize(input, {
        ALLOWED_TAGS: ['a', 'br', 'ul', 'li', 'p', 'strong', 'b', 'u', 'i', 'em', 'span', 'img'],
        ALLOWED_ATTR: ['href', 'class', 'style', 'src'],
        ALLOW_DATA_ATTR: true,
    });
};
export default sanitizeHTML;
//# sourceMappingURL=sanitizeHtml.js.map